import { ILeaderboardConfig, ILeaderboardInstance } from 'fitbeat.models';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { IAppStore } from '../../rootReducer';
import Dropdown from '../../shared/components/Dropdown';
import { setSelectedInstance } from '../leaderboardsSlice';
import { mapLeaderboardInstanceToOption, mapLeaderboardTeamsToOption } from './helpers';

interface IProps {
  mappedSelectedLeaderboardInstance: {
    label: string,
    value?: ILeaderboardInstance,
  } | null;
  leaderboardInstancesToListOptions: {
    label: string,
    value?: ILeaderboardInstance,
  }[];
  leaderboardTeamsToListOptions: { value: string, label: string }[];
  selectedGymName: string | null;
  selectedLeaderboardInstance: ILeaderboardInstance | null;
  selectedLeaderboardConfig: ILeaderboardConfig | null;
  mappedSelectedLeaderboardTeam: { value: string, label: string } | null;
  setSelectedInstance(teamDetails: {
    gym: string | null,
    leaderboardTeam: string | null,
    selectedLeaderboardInstance: ILeaderboardInstance,
  }): void;
}

class LeaderboardInstanceSelectors extends Component<IProps> {
  public render() {
    const {
      selectedGymName,
      selectedLeaderboardConfig,
      selectedLeaderboardInstance,
      leaderboardTeamsToListOptions,
      mappedSelectedLeaderboardTeam,
      leaderboardInstancesToListOptions,
      mappedSelectedLeaderboardInstance,
    } = this.props;
    const enableTeamsOptions = (mappedSelectedLeaderboardInstance && selectedLeaderboardConfig?.teams);
    return (
      <div className='leaderboard-right-date-team-container'>
        <div className='leaderboard-select-container'>
          <h4 className='leaderboard-select-title'>Date</h4>
          <Dropdown
            onChange={(selected: { label: string; value: ILeaderboardInstance }) => {
              const teamName = mappedSelectedLeaderboardTeam?.value ?? null;
              this.props.setSelectedInstance({
                gym: selectedGymName,
                leaderboardTeam: teamName,
                selectedLeaderboardInstance: selected.value,
              });
            }}
            options={leaderboardInstancesToListOptions}
            value={mappedSelectedLeaderboardInstance}
            placeholder='Select'
            className='leaderboard-select'
            classNamePrefix='select'
          />
        </div>
        {enableTeamsOptions && (
          <div className='leaderboard-select-container'>
            <h4 className='leaderboard-select-title'>Team(s)</h4>
            <Dropdown
              onChange={(selected: { label: string; value: string; }) => {
                if (selectedLeaderboardInstance) {
                  this.props.setSelectedInstance({
                    gym: selectedGymName,
                    leaderboardTeam: selected.value ?? null,
                    selectedLeaderboardInstance,
                  });
                }
              }}
              options={leaderboardTeamsToListOptions}
              value={mappedSelectedLeaderboardTeam}
              placeholder='Select'
              className='leaderboard-select'
              classNamePrefix='select'
            />
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = {
  setSelectedInstance,
};
const mapStateToProps = (state: IAppStore) => {
  const { leaderboards, adminSettings } = state;
  const { selectedGymName } = adminSettings.data;
  const {
    leaderboardInstances,
    selectedLeaderboardConfig,
    selectedLeaderboardInstance,
    selectedLeaderboardTeam,
  } = leaderboards.data;

  const leaderboardInstancesToListOptions = leaderboardInstances.map((
    singleItem: ILeaderboardInstance,
  ) => mapLeaderboardInstanceToOption(singleItem, selectedLeaderboardConfig?.timezone));
  const leaderboardTeamsToListOptions = selectedLeaderboardConfig?.teams
    ? [
      ...selectedLeaderboardConfig.teams.map(mapLeaderboardTeamsToOption),
      { label: 'All teams', value: undefined },
    ]
    : [];
  const mappedSelectedLeaderboardInstance = selectedLeaderboardInstance
    ? mapLeaderboardInstanceToOption(selectedLeaderboardInstance, selectedLeaderboardConfig?.timezone)
    : null;
  const mappedSelectedLeaderboardTeam = selectedLeaderboardTeam
    ? mapLeaderboardTeamsToOption(selectedLeaderboardTeam)
    : {
      value: undefined,
      label: 'All teams',
    };

  return {
    selectedGymName,
    selectedLeaderboardConfig,
    selectedLeaderboardInstance,
    leaderboardTeamsToListOptions,
    mappedSelectedLeaderboardTeam,
    mappedSelectedLeaderboardInstance,
    leaderboardInstancesToListOptions,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LeaderboardInstanceSelectors);
